import { parseDate } from "@internationalized/date";
import { I18nProvider } from "react-aria-components";

import { DatePicker } from "@/components/datepicker";
import {
  type SegmentedTabItem,
  SegmentedTabs,
} from "@/components/segmented-tabs";

import type { AiCostsPeriod, AiCostsSearch } from "./aiCostsSearch";

const PERIOD_TABS: SegmentedTabItem<AiCostsPeriod>[] = [
  { id: "this-month", label: "This month" },
  { id: "last-30-days", label: "Last 30 days" },
  { id: "custom", label: "Custom" },
];

type PeriodSearch = Pick<AiCostsSearch, "from" | "period" | "to">;

interface AiCostsPeriodFilterProps {
  onChange: (period: PeriodSearch) => void;
  value: PeriodSearch;
}

export function AiCostsPeriodFilter({
  onChange,
  value,
}: AiCostsPeriodFilterProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
      <SegmentedTabs
        onTabChange={(period) => onChange({ ...value, period })}
        selectedTab={value.period}
        tabs={PERIOD_TABS}
      />

      {value.period === "custom" && (
        <I18nProvider locale="en-US">
          <div className="flex gap-3">
            <DatePicker
              aria-label="From"
              onChange={(date) =>
                onChange({ ...value, from: date?.toString() })
              }
              value={value.from ? parseDate(value.from) : null}
            />
            <DatePicker
              aria-label="To"
              onChange={(date) => onChange({ ...value, to: date?.toString() })}
              value={value.to ? parseDate(value.to) : null}
            />
          </div>
        </I18nProvider>
      )}
    </div>
  );
}
